import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkButton } from '@eika/button';
import { formatCurrencyValue } from '@eika/currency-input';

import { piwikTrackId, piwikTrackName } from '../gtm/gtmUtils';
import { useMarkedsrente } from '../hooks/hooks';
import calculateNedbetalingsplan from './nedbetalingsplanList';

export interface NedbetalingsplanProps {
    laanebeloep: number;
    rente: number;
    nedbetalingstid: number;
    showNedbetalingsplan: boolean;
    setShowNedbetalingsplan: (showNedbetalingsplan: boolean) => void;
}

const Nedbetalingsplan: FC<NedbetalingsplanProps> = ({
    laanebeloep,
    rente,
    nedbetalingstid,
    setShowNedbetalingsplan,
    showNedbetalingsplan,
}) => {
    const { t } = useTranslation();
    const { data: markedsrente } = useMarkedsrente();

    const nedbetalingsplanList = calculateNedbetalingsplan(
        laanebeloep,
        rente,
        nedbetalingstid,
        markedsrente?.terminGebyr || 0,
        markedsrente?.etableringsGebyr || 0,
    );

    return (
        <div className="nedbetalingsplan">
            <div className="header-group">
                <h3>{t('nedbetalingsplan.nedbetalingsplan')}</h3>
                <LinkButton
                    onClick={() => setShowNedbetalingsplan(!showNedbetalingsplan)}
                    data-track-id={piwikTrackId('nedbetalingsplan')}
                    data-track-linkname={piwikTrackName('lukk')}
                >
                    {t('nedbetalingsplan.lukk')}
                </LinkButton>
            </div>
            <table>
                <tbody>
                    <tr>
                        <th>{t('nedbetalingsplan.aar')}</th>
                        <th>{t('nedbetalingsplan.aaBetale')}</th>
                        <th>{t('nedbetalingsplan.avdrag')}</th>
                        <th className="wrap">{t('nedbetalingsplan.renterOgGebyr')}</th>
                        <th>{t('nedbetalingsplan.restgjeld')}</th>
                    </tr>
                    {nedbetalingsplanList.map((n, index) => (
                        <tr key={`nedbetaling_${index.toString()}`}>
                            <td>{n.termin - 1}</td>
                            <td>{formatCurrencyValue(n.innbetaling)}</td>
                            <td>{formatCurrencyValue(n.avdrag)}</td>
                            <td>{formatCurrencyValue(n.renterOgGebyr)}</td>
                            <td>{formatCurrencyValue(n.restgjeld)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default Nedbetalingsplan;
